var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" けろよーん "+_vm._s(_vm.$isLogin)+" "),_c('Login',{attrs:{"tosUrl":"https://connect.uedasoft.com/docs/tos.html","privacyPolicyUrl":"https://connect.uedasoft.com/docs/privacy.html"}}),_c('v-btn',{on:{"click":_vm.registerOwner}},[_vm._v(" register ")]),_c('v-btn',{on:{"click":_vm.cancelOwner}},[_vm._v(" cancel ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }